export function clearLocalStorage() {
  localStorage.removeItem('id_token');
  localStorage.removeItem('role');
  localStorage.removeItem('role_id');
  localStorage.removeItem('user');
  localStorage.removeItem('user_id');
  localStorage.removeItem('fcm_token');
  localStorage.removeItem('location_permission');
  localStorage.removeItem('group_permission');
  localStorage.removeItem('subgroup_permission');
  localStorage.removeItem('select_module');
  localStorage.removeItem('select_group');
  localStorage.removeItem('subgroup_type');
  localStorage.removeItem('sort');
  localStorage.removeItem('last_view');
  localStorage.removeItem('patient_id');
  localStorage.removeItem('tenantInfo');
  localStorage.removeItem('tenant_permission');
  localStorage.removeItem('select_tenant');
  // debugger;
  return true;
}

export function setSelectTenant(tenantIds) {
  localStorage.removeItem('select_tenant');
  localStorage.removeItem('select_module');
  localStorage.removeItem('select_group');
  if (tenantIds.length === 1) {
    localStorage.setItem('select_tenant', tenantIds[0]);
  }
  return true;
}

export const fullname = (language, data) => {
  let fullname = '';
  if (language && language === 'th-TH') {
    if (data.firstname || data.lastname) {
      fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
    } else {
      fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
    }
  }

  if (language && language === 'en-EN') {
    if (data.firstnameEn || data.lastnameEn) {
      fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
    } else {
      fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
    }
  }

  return fullname;
};

export const typeList = [
  {
    name: 'AiR (without encryption)',
    category: 'AIRNODE',
    property: {
      activateButton: 1,
      motionTracker: 1,
      alarmTrigger: 0,
      alarmOnoff: 0,
      signal: 1,
      localization: 1,
      areaRestriction: 1,
    },
  },
  {
    name: 'AiR (with encryption)',
    category: 'AIRNODE',
    property: {
      activateButton: 0,
      motionTracker: 1,
      alarmTrigger: 0,
      alarmOnoff: 0,
      signal: 1,
      localization: 1,
      areaRestriction: 1,
    },
  },
  {
    name: 'beacon',
    category: 'BEACON_TAG',
    property: {
      activateButton: 0,
      motionTracker: 0,
      alarmTrigger: 0,
      alarmOnoff: 0,
      signal: 1,
      localization: 1,
      areaRestriction: 1,
    },
  },
  {
    name: 'on/off button',
    category: 'EMERGENCY_BUTTON',
    property: {
      activateButton: 0,
      motionTracker: 0,
      alarmTrigger: 0,
      alarmOnoff: 1,
      signal: 1,
      localization: 0,
      areaRestriction: 0,
    },
  },
  {
    name: 'wearable on/off button',
    category: 'EMERGENCY_BUTTON',
    property: {
      activateButton: 0,
      motionTracker: 0,
      alarmTrigger: 0,
      alarmOnoff: 1,
      signal: 1,
      localization: 1,
      areaRestriction: 0,
    },
  },
  {
    name: 'trigger button',
    category: 'EMERGENCY_BUTTON',
    property: {
      activateButton: 0,
      motionTracker: 0,
      alarmTrigger: 1,
      alarmOnoff: 0,
      signal: 1,
      localization: 0,
      areaRestriction: 0,
    },
  },
  {
    name: 'wearable trigger button',
    category: 'EMERGENCY_BUTTON',
    property: {
      activateButton: 0,
      motionTracker: 0,
      alarmTrigger: 1,
      alarmOnoff: 0,
      signal: 1,
      localization: 1,
      areaRestriction: 0,
    },
  },
];

export const languages = [
  { label: 'ไทย', value: 'th-TH' },
  { label: 'English', value: 'en-EN' },
];
